import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

// `env` modul yuklanganda tekshiriladi: noto'g'ri sozlama ilovani darhol to'xtatadi.
import "@/configs/env";
import "@/configs/i18n";
import { initSentry } from "@/configs/sentry";

import App from "./App";
import "./index.css";

// Ushlanmagan xatolar va rad etilgan promise'lar — Sentry'ga (DSN bo'lsa).
initSentry(import.meta.env);

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("#root topilmadi — index.html buzilgan.");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
